<template>
    <div class="sort-select">
        <b-form-select v-model="order">
            <b-form-select-option
                v-for="entry in orderEntriesFiltered"
                :key="entry.value"
                :value="entry.value"
                :disabled="entry.value === order"
            >
                {{ $t(entry.label) }}
            </b-form-select-option>
        </b-form-select>
    </div>
</template>

<script>
import {
    BFormSelect, BFormSelectOption
} from "bootstrap-vue";
import { EventBus } from "../../event-bus"

export default {
    name: 'SortSelect',
    components: {
        BFormSelect, BFormSelectOption
    },
    data() {
        return {
            order: 'rankingDesc',
            isInit: false,
            orderEntries: [
                {
                    label: 'cat.filter.label.popularity',
                    value: 'rankingDesc',
                    apiName: 'ranking',
                },
                {
                    label: 'cat.filter.label.price_rising',
                    value: 'priceAsc',
                    apiName: 'price_asc',
                },
                {
                    label: 'cat.filter.label.price_descending',
                    value: 'priceDesc',
                    apiName: 'price_desc',
                },
                {
                    label: 'cat.filter.label.newest_first',
                    value: 'activeSince',
                    apiName: 'newest',
                }
            ]
        }
    },
    methods: {
        updateOrder(data){
            if(this.isInit)
                return;

            const exists = this.orderEntries.find(o => o.value === data);
            if(exists){
                this.order = data
            }

            this.isInit = true;
        },

        selectFirst() { 
            if(this.$route.query.sort)
                this.order = this.$route.query.sort;
            else
                this.order = this.orderEntriesFiltered[0].value;
        },
    },
    computed: {
        orderEntriesFiltered() {
            let settings = this.$root.whitelabel.getSettings();
            const sortrings = settings.sortings;

            return this.orderEntries.filter(ent => sortrings.includes(ent.apiName));
        }
    },
    watch: {
        order: function (val) {
            // fallback if order is set by url
            EventBus.$emit('update-catalog-filter', {filter:"sort", value: this.order});
        },
    },
    mounted() {
        this.selectFirst();
        EventBus.$on('update-catalog-sort-by-route', this.updateOrder);
    }
}
</script>